type PortalTarget = string | HTMLElement;

function resolveTarget(target: PortalTarget): HTMLElement | null {
  if (typeof target === 'string') {
    return document.querySelector(target) as HTMLElement | null;
  }
  return target;
}

export function portal(node: HTMLElement, target: PortalTarget = 'body') {
  let targetEl = resolveTarget(target);

  if (targetEl) {
    targetEl.appendChild(node);
  }

  return {
    update(nextTarget: PortalTarget) {
      const nextEl = resolveTarget(nextTarget);
      if (!nextEl || nextEl === targetEl) return;
      nextEl.appendChild(node);
      targetEl = nextEl;
    },
    destroy() {
      node.remove();
    },
  };
}
